import { createSlice } from "@reduxjs/toolkit";

const cartSlice = createSlice({
    name: 'cart',
    initialState: {
        totalAmount: '0.00',
        goods: [],
        promocode: '',
        server: 0,
        tips: 5
    },
    reducers: {
        addToCart(state, data){
            state.goods.push(data.payload);
            state.totalAmount =( parseFloat(state.totalAmount) + parseFloat(data.payload.total)).toFixed(2);
            
            const cartObject = {...state};
            cartObject.promocode = '';
            localStorage.setItem("cart", JSON.stringify(cartObject));
        },
        removeFromCart(state, data){
            const itemId = data.payload;

            const newProducts = state.goods.filter(item => item.id !== itemId);

            state.goods.forEach(item => {
                if(item.id === itemId){
                    state.totalAmount = (parseFloat(state.totalAmount) - parseFloat(item.total)).toFixed(2);
                }
            })

            state.goods = newProducts;

            const cartObject = {...state};
            cartObject.promocode = '';
            localStorage.setItem("cart", JSON.stringify(cartObject));
        },
        setPromocode(state, data){
            state.promocode = data.payload;
        },
        setCart(state, data){
            state.totalAmount = data.payload.totalAmount;
            state.goods = data.payload.goods;
            state.promocode = data.payload.promocode;
        },
        setServer(state, data){
            state.server = data.payload;
        },
        setTips(state, data){
            state.tips = data.payload;
        }
    }
});

export const cartActions = cartSlice.actions;
export default cartSlice;